import {Button, Card, Stack, Typography} from "@mui/material";
import React, {useState} from "react";
import {pageAuthorizedByGroup} from "../fragments/PageAuthorization";
import {Link} from "react-router-dom";
import {AppRegistration, Compare, ContentPasteSearch, ElectricBolt, MoneySharp} from "@mui/icons-material";
import {translateFunction} from "../../localization/TranslationService";
import {EnvironmentStage} from "../../data/EnvironmentStage";

const translate = translateFunction("SureBasePortalProductsCatalog");
export const ReportModuleOverview = pageAuthorizedByGroup(function () {
	useState<string>("");
	return <>
		<Stack direction={"row"} justifyContent={"space-evenly"} style={{width: "100%"}}>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "300px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<MoneySharp fontSize={"large"}/>
						<Typography>{translate("Products commission setup report")}</Typography>
					</div>
					<Stack alignItems={"center"}>
						<Button component={Link} to={"./products_incentive_setup_report"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "300px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<AppRegistration fontSize={"large"}/>
						<Typography>{translate("Incentive register report")}</Typography>
					</div>
					<Stack alignItems={"center"}>
						<Button component={Link} to={"./incentive_register_report"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "300px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<ContentPasteSearch fontSize={"large"}/>
						<Typography>{translate("Custom orders report")}</Typography>
					</div>
					<Stack alignItems={"center"}>
						<Button component={Link} to={"./custom_orders_report"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "300px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<ElectricBolt fontSize={"large"}/>
						<Typography>{translate("Energy auction report")}</Typography>
					</div>
					<Stack alignItems={"center"}>
						<Button component={Link} to={"./energy_auction_report"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "300px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<Compare fontSize={"large"}/>
						<Typography>{translate("Comparator intakes report")}</Typography>
					</div>
					<Stack alignItems={"center"}>
						<Button component={Link} to={"./comparator_intakes_report"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
		</Stack>
	</>;
}, ["Admin"]);

export const reportsDefaultTargetStage: EnvironmentStage = "dev";

